import React, {useEffect, useLayoutEffect, useRef, useState} from "react";
import useWindowSize from "../../../hooks/use-window/size";
import classnames from "classnames";

const ContentRelatedTopicsSlider = ({content}) => {
    const [fullWidth, setFullWidth] = useState(0);
    const [currentScrollPosition, setCurrentScrollPosition] = useState(0);
    const [clientWidth, setClientWidth] = useState(0);
    const windowSize = useWindowSize();
    const parentRef = useRef(null);
    const trackRef = useRef(null);
    const listRef = useRef(null);

    const canScrollPrev = currentScrollPosition > 0;
    const canScrollNext = currentScrollPosition < fullWidth - clientWidth;

    /**
     * Listens for the changes in the width of viewPort and calculates the available clientWidth of the slider.
     */
    useLayoutEffect(() => {
        if (!parentRef.current) return;
        const width = parentRef.current.clientWidth;
        if (clientWidth !== width) setClientWidth(width);
    }, [parentRef.current, windowSize?.width])


    /**
     * As soon as the track element is mounted, calculates its full width based on its children's width.
     */
    useEffect(() => {
        if (!trackRef.current) return;
        const _fullWidth = trackRef.current.scrollWidth;
        if (_fullWidth !== fullWidth) setFullWidth(_fullWidth);
    }, [trackRef.current])


    /**
     * Scrolls the list of elements by maximum of clientWidth to right
     */
    const onNextClick = () => {
        const newScrollPosition = Math.min(fullWidth, clientWidth + currentScrollPosition);
        listRef.current.scrollTo({left: newScrollPosition});
    }

    /**
     * Scrolls the list of elements by maximum of clientWidth to left.
     */
    const onPrevClick = () => {
        const newScrollPosition = Math.max(0, currentScrollPosition - clientWidth);
        listRef.current.scrollTo({left: newScrollPosition});
    }

    /**
     * Sets the scroll position of the list element with each change in scroll
     * @param {UIEvent} e
     */
    const onScroll = (e) => {
        setCurrentScrollPosition(e.target?.scrollLeft ?? 0);
    }


    return (
        <>
            <div className={'slick-slider slick-initialized content-related-topics-slider'} ref={parentRef}>
                <div
                    className={classnames('slick-arrow slick-prev', {'slick-disabled': !canScrollPrev})}
                    onClick={onPrevClick}
                />
                <div className={'slick-list'} onScroll={onScroll} ref={listRef}>
                    <div className={'slick-track d-flex mb-2'} ref={trackRef}>
                        {
                            content.map((content, index) => (
                                <div className={'slick-slide'} key={index}>
                                    <div id={index}>
                                        {content}
                                    </div>
                                </div>

                            ))
                        }
                    </div>
                </div>
                <div
                    className={classnames('slick-arrow slick-next', {'slick-disabled': !canScrollNext})}
                    onClick={onNextClick}
                />
            </div>
        </>
    );
}

export default ContentRelatedTopicsSlider;
